import React from 'react'

const reviews = [
  {
    name: 'Tim C',
    rating: 5,
    date: 'vor 2 Tagen',
    text: 'Einwandfrei, schnelle und sehr gute Arbeit beim Akkutausch meines Macbooks.',
  },
  {
    name: 'Face Fisch',
    rating: 5,
    date: 'vor einem Monat',
    text: 'Mein MacBook hatte einen ziemlich komplizierten Fehler, kein Bild intern und extern und zusätzlich noch einen älteren Flüssigkeitsschaden. Andere hätten da wahrscheinlich direkt aufgegeben. Hier wurde aber sauber und systematisch gearbeitet. Gerade im Bereich Microsoldering merkt man, dass hier wirklich Ahnung vorhanden ist. Am Ende wurde das Logicboard gereinigt und das Display ersetzt – zu einem absolut fairen Preis. Klare Empfehlung!',
  },
  {
    name: 'Hyrum Shumway',
    rating: 5,
    date: 'vor 5 Monaten',
    text: 'Konrad war fantastisch und hat mir den Kauf eines neuen Computers erspart, indem er das Logicboard repariert hat. Ich war schon in anderen Werkstätten, aber keine hat so gut repariert wie Konrad. Die meisten tauschen einfach Teile aus, aber Konrad hat eine Herausforderung gemeistert, die laut mehreren Leuten unmöglich war. Vielen Dank!',
  },
  {
    name: 'Daniel Eichenseer',
    rating: 5,
    date: 'vor 7 Monaten',
    text: 'Mein iMac hatte einen Defekt, den ich zuerst bei einem zertifizierten Apple Händler reparieren lassen wollte. Der Händler wollte über 700 €. Bei PhoneMedic wurde mein iMac mit einfachsten Mitteln repariert. Die 700 € habe ich mir gespart. Vielen Dank!',
  },
  {
    name: 'Mateusz K',
    rating: 5,
    date: 'vor 2 Jahren',
    text: 'Ich dachte mein Handy ist nicht mehr zu retten nach einem Wasserschaden, aber für PhoneMedic war das gar kein Problem. Super schnell und zuverlässig!! Kann ich nur weiterempfehlen!!',
  },
  {
    name: 'Anna Will',
    rating: 5,
    date: 'vor einem Jahr',
    text: 'Absolute Empfehlung! Total unkomplizierte Abwicklung und sehr freundlicher Kontakt. Herr Blersch hat das Ersatzteil vorab bestellt, sodass ich mein Handy nach wenigen Stunden zurückbekommen habe. Super Preis-Leistungs-Verhältnis!',
  },
  {
    name: 'Ruth-M. R.',
    rating: 5,
    date: 'vor 3 Monaten',
    text: 'Ich habe den Akku von meinem iPhone 12 wechseln lassen. Der Wechsel ging super schnell und der Service ist sehr kundenorientiert. Große Empfehlung an alle! :)',
  },
]

const StarRating: React.FC<{ rating: number }> = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((star) => (
      <svg
        key={star}
        className={`w-4 h-4 ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
)

const ReviewsSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Das sagen unsere Kunden</h2>
          <div className="flex items-center justify-center gap-2 mt-3">
            <StarRating rating={5} />
            <span className="font-semibold text-gray-900">4,9</span>
            <span className="text-gray-500 text-sm">· 33 Google-Bewertungen</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-sm">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">{review.name}</div>
                    <div className="text-xs text-gray-400">{review.date}</div>
                  </div>
                </div>
                <svg className="w-5 h-5 text-[#4285F4]" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
              </div>
              <StarRating rating={review.rating} />
              <p className="text-gray-600 text-sm leading-relaxed line-clamp-4">{review.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://www.google.com/maps/place/PhoneMedic/@50.7018861,-0.0515184,5z/data=!3m1!4b1!4m6!3m5!1s0x601560890a4c6ea7:0x18cbbef6bda09870!8m2!3d51.175807!4d10.4541194!16s%2Fg%2F11vm5zs0dh!5m1!1e4"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-700 font-medium"
          >
            Alle Bewertungen auf Google ansehen →
          </a>
        </div>
      </div>
    </section>
  )
}

export default ReviewsSection
